export const products = {
  categories: [
    {
      id: 'djemba-bags',
      name: 'Djemba Bags',
      description: 'Premium handcrafted bags designed specifically for your percussion instruments. Each bag is made with high-quality leather and expert craftsmanship.',
      images: [
        '/images/djemba-bags/1.jpg',
        '/images/djemba-bags/2.jpg',
        '/images/djemba-bags/3.jpg',
        '/images/djemba-bags/4.jpg'
      ],
      features: [
        'Durable leather construction',
        'Padded interior for protection',
        'Adjustable shoulder straps',
        'Multiple storage compartments',
        'Water-resistant design',
        'Heavy-duty zippers'
      ],
      details: {
        material: 'Premium full-grain leather',
        dimensions: '24" x 12" x 12"',
        weight: '2.5 kg',
        colors: ['Brown', 'Black', 'Tan'],
        lining: 'Soft padded fabric',
        closure: 'YKK heavy-duty zippers'
      }
    },
    {
      id: 'drum-heads',
      name: 'Drum Heads',
      description: 'Professional quality leather drum heads crafted for optimal sound and durability. Each piece is carefully selected and treated for the best acoustic performance.',
      images: Array.from({ length: 21 }, (_, i) => 
        `/images/drum-heads/${i + 1}${i >= 18 ? '.jpeg' : '.jpg'}`
      ),
      features: [
        'Natural leather construction',
        'Superior sound quality',
        'Long-lasting durability',
        'Various sizes available',
        'Professional grade materials',
        'Hand-stretched and tested'
      ],
      details: {
        material: 'Natural goat leather',
        sizes: ['8"', '10"', '12"', '14"', '16"', '18"'],
        thickness: '1.5-2mm',
        finish: 'Natural, untreated',
        treatment: 'Hand-stretched and cured',
        soundProfile: 'Rich, warm tones'
      }
    },
    {
      id: 'frame-bags',
      name: 'Frame Bags',
      description: 'Elegant leather bags featuring sturdy frames and premium craftsmanship. Perfect for both style and functionality.',
      images: Array.from({ length: 5 }, (_, i) => 
        `/images/frame-bags/${i + 1}${i >= 2 ? '.jpg' : '.jpeg'}`
      ),
      features: [
        'Sturdy metal frame construction',
        'Premium leather exterior',
        'Lined interior compartments',
        'Multiple storage sections',
        'Secure clasp closure',
        'Adjustable straps'
      ],
      details: {
        material: 'Full-grain leather',
        dimensions: '16" x 8" x 6"',
        weight: '1.2 kg',
        colors: ['Brown', 'Black'],
        hardware: 'Brass fittings',
        lining: 'Premium fabric'
      }
    },
    {
      id: 'dundun-sticks',
      name: 'Dundun Sticks',
      description: 'Professional grade dundun sticks crafted for optimal sound and performance. Made from select hardwoods with perfect balance.',
      images: [
        '/images/dundun-sticks/1.jpg',
        '/images/dundun-sticks/2.jpg'
      ],
      features: [
        'Perfectly balanced weight',
        'Ergonomic grip design',
        'Premium hardwood construction',
        'Professional quality finish',
        'Durable and long-lasting',
        'Multiple sizes available'
      ],
      details: {
        material: 'Select hardwood',
        length: '14 inches',
        weight: '200g per stick',
        finish: 'Natural wood oil',
        grip: 'Ergonomic design',
        woodType: 'African hardwood'
      }
    },
    {
      id: 'wooden-claves',
      name: 'Wooden Claves',
      description: 'Traditional wooden percussion instruments crafted for perfect resonance and tone. Made from specially selected hardwoods.',
      images: Array.from({ length: 6 }, (_, i) => 
        `/images/wooden-claves/${i + 1}${i === 0 ? '.png' : '.jpg'}`
      ),
      features: [
        'Rich, clear tonal quality',
        'Traditional design',
        'Premium hardwood construction',
        'Perfect resonance',
        'Balanced weight',
        'Smooth finish'
      ],
      details: {
        material: 'Premium hardwood',
        length: '8 inches',
        diameter: '1.25 inches',
        finish: 'Natural polish',
        sound: 'Clear, crisp tones',
        woodType: 'Select hardwood'
      }
    },
    {
      id: 'lacing-rope',
      name: 'Lacing Rope',
      description: 'High-quality ropes specifically designed for instrument maintenance and tuning. Durable and weather-resistant.',
      images: Array.from({ length: 7 }, (_, i) => 
        `/images/lacing-rope/${i + 1}.jpg`
      ),
      features: [
        'Durable construction',
        'Weather-resistant material',
        'Multiple sizes available',
        'Professional grade quality',
        'High tensile strength',
        'Long-lasting performance'
      ],
      details: {
        material: 'Nylon/Cotton blend',
        lengths: ['5m', '10m', '15m', '20m'],
        thickness: '3mm',
        colors: ['Natural', 'Black'],
        strength: 'High tensile',
        treatment: 'Weather-resistant'
      }
    }
  ],
  featured: [
    {
      id: 'djemba-bag-premium',
      categoryId: 'djemba-bags',
      name: 'Premium Djemba Bag',
      description: 'Our flagship djemba bag featuring premium leather and superior craftsmanship',
      image: '/images/djemba-bags/1.jpg'
    },
    {
      id: 'drum-head-pro',
      categoryId: 'drum-heads',
      name: 'Professional Drum Head',
      description: 'Professional grade drum head crafted for superior sound quality',
      image: '/images/drum-heads/1.jpg'
    },
    {
      id: 'frame-bag-classic',
      categoryId: 'frame-bags',
      name: 'Classic Frame Bag',
      description: 'Timeless design combined with modern functionality',
      image: '/images/frame-bags/1.jpeg'
    },
    {
      id: 'dundun-stick-pro',
      categoryId: 'dundun-sticks',
      name: 'Professional Dundun Sticks',
      description: 'Perfectly balanced sticks for professional performance',
      image: '/images/dundun-sticks/1.jpg'
    }
  ],
  new: [
    {
      id: 'wooden-claves-premium',
      categoryId: 'wooden-claves',
      name: 'Premium Wooden Claves',
      description: 'New premium wooden claves with enhanced resonance',
      image: '/images/wooden-claves/1.png'
    },
    {
      id: 'lacing-rope-pro',
      categoryId: 'lacing-rope',
      name: 'Professional Lacing Rope',
      description: 'New professional grade lacing rope with improved durability',
      image: '/images/lacing-rope/1.jpg'
    }
  ]
};

export const getCategory = (id) => {
  return products.categories.find(category => category.id === id);
};

export const getFeaturedProducts = () => {
  return products.featured;
};

export const getNewProducts = () => {
  return products.new;
};

export const getAllProducts = () => {
  return [
    ...products.featured,
    ...products.new
  ];
};

export default products;
